export enum Status {
    READ,
    UNREAD,
    DELETED,
}
